import React, { useState, useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import { connect } from 'react-redux';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { numberFormat, numberWithCommas, validNumberCheck, replaceCommas, findArrayObjectIndex } from '../../../utils/utils';
import * as logger from '../../../logger';
import {
    TextField,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete,
    Switches,
    Checkboxes
} from 'mui-rff';
import { Form } from 'react-final-form';
import {
    Grid,
    IconButton,
    Button,
    InputAdornment,
    MenuItem
} from '@material-ui/core';
import TextInputState from '../Inputs/TextInputState';
import { YourDetailsSideBarCss } from './InvoiceSideBarCss';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import DateFnsUtils from '@date-io/date-fns';
import EnterDaysDialog from '../Dialog/EnterDaysDialog';
import { editInvoice } from '../../../store/actions/tripActionCreator';
import { updateChatView, invoiceConfig } from "../../../store/actions/userActionCreators";


const InvoiceDetailsSideBar = ({
    open,
    onClose,
    onConfirm,
    trip,
    user,
    sideBarName,
    dispatchEditInvoice,
    dispatchChatView,
    dispatchGetInvoiceConfig
}) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [invoiceDetailsValue, setInvoiceDetailsValue] = useState("")
    const [dueDateValue, setDueDateValue] = useState("");
    const [daysValue, setDaysValue] = useState("");
    const [enterDaysFlag, setEnterDaysFlag] = useState(false);
    const [confirmDisabled, setConfirmDisabled] = useState(false);
    const [invoiceConfigData, setInvoiceConfigData] = useState({ dueDays: [] });
    const [invoiceIdValue, setInvoiceIdValue] = useState("");
    const [invoiceDateValue, setInvoiceDateValue] = useState(new Date());

    const classes = YourDetailsSideBarCss();

    const initialValues = {
        invoiceNumber: invoiceDetailsValue,
        invoiceDate: invoiceDateValue,
        dueDate: dueDateValue,
        days: daysValue
    }

    useEffect(() => {
        dispatchChatView(false);
        dispatchGetInvoiceConfig(
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Invoice Details Side Bar Dweb', 'Get Invoice Config Successfull');
                }
            },
            () => {
                logger.log('Invoice Details Side Bar Dweb', 'Get Invoice Config Failed');
            }
        )
    }, []);

    useEffect(() => {

        const configData = user.invoiceConfig;

        let indexValue;

        if (trip && trip.singleInvoiceInfo && trip.singleInvoiceInfo.invoiceDetails) {

            setInvoiceDetailsValue(trip.singleInvoiceInfo.invoiceDetails.invoiceNumber ? trip.singleInvoiceInfo.invoiceDetails.invoiceNumber : "");
            setDueDateValue(trip.singleInvoiceInfo.invoiceDetails.dueDate ? trip.singleInvoiceInfo.invoiceDetails.dueDate * 1000 : "");
            setInvoiceDateValue(trip.singleInvoiceInfo.invoiceDetails.invoiceDate ? new Date(trip.singleInvoiceInfo.invoiceDetails.invoiceDate * 1000) : "")

            const dueDateDetails = trip && trip.singleInvoiceInfo && trip.singleInvoiceInfo.invoiceDetails && trip.singleInvoiceInfo.invoiceDetails.dueDate ? trip.singleInvoiceInfo.invoiceDetails.dueDate : "";
            const invoiceDateDetails = trip && trip.singleInvoiceInfo && trip.singleInvoiceInfo.invoiceDetails && trip.singleInvoiceInfo.invoiceDetails.invoiceDate ? trip.singleInvoiceInfo.invoiceDetails.invoiceDate : "";
            const diffTime = Math.abs(Number(invoiceDateDetails * 1000) - Number(dueDateDetails * 1000));
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (configData && configData.dueDays && configData.dueDays.length > 0) {

                // const searchDays = configData.dueDays.find(dueDaysData => Number(dueDaysData.quantity) == (diffDays ? Number(diffDays) : 0));

                // if (!searchDays) {
                if ((diffDays || diffDays == 0) && configData && configData.dueDays && !configData.dueDays.some((dueDay) => Number(dueDay.quantity) === Number(diffDays))) {
                    configData.dueDays.reduce(function (accumulator, days, index) {
                        if (Number(diffDays) > Number(days.quantity)) {
                            indexValue = index;
                        }
                    });
                    configData.dueDays.splice((indexValue + 1), 0, { display: diffDays + (diffDays == 1 ? ' Day' : ' Days'), unit: 'day', quantity: Number(diffDays) });
                }
                // }
            }

            setDaysValue(diffDays);
            setInvoiceIdValue(trip.singleInvoiceInfo.invoiceDetails.id ? trip.singleInvoiceInfo.invoiceDetails.id : "");

        }

        if (user && user.invoiceConfig) {
            setInvoiceConfigData(configData);
        }


    }, [trip.singleInvoiceInfo, user.invoiceConfig, open]);

    const validate = values => {

        const errors = {};

        if (values && !values.invoiceNumber) {
            errors.invoiceNumber = "Please enter invoice number."
        }
        if (values && !values.invoiceDate) {
            errors.invoiceDate = "Please select invoice date."
        }
        if (values && !values.dueDate) {
            errors.dueDate = "Please select due date."
        }

        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }

        return errors;

    }

    const onSubmit = values => {

        const invoiceData = {
            invoiceDetails: {
                invoiceNumber: values && values.invoiceNumber ? values.invoiceNumber : "",
                invoiceDate: values && values.invoiceDate ? Math.round((values.invoiceDate.setHours(0, 0, 0, 0) / 1000)) : "",
                dueDate: values && values.dueDate ? Math.round((values.dueDate / 1000)) : ""
            }
        }

        dispatchEditInvoice(invoiceIdValue,
            invoiceData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    setDialogOpen(false);
                    onConfirm();
                    logger.log("Invoice Details Side Bar Dweb", "Edit invoice successfull");
                }
            },
            () => {
                logger.log("Invoice Details Side Bar Dweb", "Edit invoice failed");
            }
        )

    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        dispatchChatView(true);
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <>
                        <div className={classes.titleV1}>Invoice Number*</div>
                        <TextInputState
                            placeholder="Enter Invoice Details"
                            name="invoiceNumber"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setInvoiceDetailsValue(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />

                    </>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>Invoice Date*</div>
                        <DatePicker
                            name="invoiceDate"
                            margin="none"
                            variant="inline"
                            onChange={(date) => {
                                setInvoiceDateValue(date);
                                let dueDateCal = new Date();
                                dueDateCal.setDate(date.getDate() + (values && values.days ? Number(values.days) : 0));
                                setDueDateValue(dueDateCal.getTime());
                            }}
                            inputVariant="outlined"
                            size="small"
                            format="dd-MM-yyyy"
                            placeholder="Select Invoice Date"
                            dateFunsUtils={DateFnsUtils}
                            required={true}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                            InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>Due Date*</div>
                        <DatePicker
                            name="dueDate"
                            margin="none"
                            variant="inline"
                            onChange={(date) => {
                                handleDueDateChange(date, values.invoiceDate);
                            }}
                            minDate={invoiceDateValue}
                            inputVariant="outlined"
                            size="small"
                            format="dd-MM-yyyy"
                            placeholder="Select Date"
                            dateFunsUtils={DateFnsUtils}
                            required={true}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">
                                    <div className={classes.divAlignV2}>
                                        <EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon>
                                        <div>
                                            <Select
                                                name="days"
                                                variant="outlined"
                                                onChange={(e) => {
                                                    handleDaysSelectChange(e)
                                                }}
                                                onClose={(e) => {
                                                    e.stopPropagation();
                                                }}
                                                formControlProps={{ margin: 'none', size: "small" }}
                                                required={true}
                                                style={{ backgroundColor: '#efefef', color: '#7b7b7b', height: 26, marginLeft: 12 }}
                                                classes={{ root: classes.selectRoot }}
                                            >
                                                {invoiceConfigData && invoiceConfigData.dueDays && invoiceConfigData.dueDays.map((dueData, index) => {
                                                    return (<MenuItem key={index} value={dueData.quantity} className={classes.menuItem} >{dueData.display}</MenuItem>);
                                                })}
                                            </Select>
                                        </div>
                                    </div>
                                </InputAdornment>
                            }}
                        />
                    </div>
                )
            }
        ]
    }

    const handleDueDateChange = (date, invoiceDateInfo) => {

        let indexValue;
        const invoiceDateDetails = invoiceDateInfo;

        const diffTime = Math.abs(Number(invoiceDateDetails.getTime()) - Number(date.getTime()));

        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (invoiceConfigData && invoiceConfigData.dueDays && invoiceConfigData.dueDays.length > 0) {

            if ((diffDays || diffDays == 0) && invoiceConfigData && invoiceConfigData.dueDays && !invoiceConfigData.dueDays.some((dueDay) => Number(dueDay.quantity) === Number(diffDays))) {
                invoiceConfigData.dueDays.reduce(function (accumulator, days, index) {
                    if (Number(diffDays) > Number(days.quantity)) {
                        indexValue = index;
                    }
                });

                invoiceConfigData.dueDays.splice((indexValue + 1), 0, { display: diffDays + (diffDays == 1 ? ' Day' : ' Days'), unit: 'day', quantity: Number(diffDays) });
            }
        }

        setDueDateValue(date.getTime());
        setDaysValue(diffDays);

    }

    const handleDaysSelectChange = (e) => {
        if (e && e.target && e.target.value == "Custom") {
            setEnterDaysFlag(true);
        } else {

            // ****************************** Calculating Invoice Due Date based on number of days. ****************************** 
            var dueDateCal = new Date(invoiceDateValue);
            dueDateCal.setDate(dueDateCal.getDate() + (e && e.target && e.target.value ? Number(e.target.value) : 0));
            setDaysValue(e.target.value);
            setDueDateValue(dueDateCal.getTime());
            e.stopPropagation();
        }
    }

    const handleDaysDialogClose = () => {
        setEnterDaysFlag(false);
    }

    const handleDaysDialogConfirm = (days) => {

        let indexValue;
        setDaysValue(days);
        setEnterDaysFlag(false);

        if (invoiceConfigData && invoiceConfigData.dueDays && invoiceConfigData.dueDays.length > 0) {

            if (days && invoiceConfigData && invoiceConfigData.dueDays && !invoiceConfigData.dueDays.some((dueDay) => Number(dueDay.quantity) === Number(days))) {
                invoiceConfigData.dueDays.reduce(function (accumulator, daysInfo, index) {
                    if (Number(days) > Number(daysInfo.quantity)) {
                        indexValue = index;
                    }
                });
                invoiceConfigData.dueDays.splice((indexValue + 1), 0, { display: days + (days == 1 ? ' Day' : ' Days'), unit: 'day', quantity: Number(days) });
            }

        }

        var dueDateCal = new Date(invoiceDateValue);
        dueDateCal.setDate(dueDateCal.getDate() + (days ? Number(days) : 0));
        setDueDateValue(dueDateCal.getTime());
    }


    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >
                <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} onClose={handleClose} className={classes.dialogTitle} >
                    <div className={classes.divTitle}>
                        Invoice Details
                    </div>
                </SideBarDialogTitle >

                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >

                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit; return (
                                <form onSubmit={handleSubmit} noValidate>
                                    <Grid container alignItems="flex-start" spacing={0}>
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />

                </SideBarDialogContent>

                <SideBarDialogActions className={classes.dialogActions} >

                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()}>
                        Cancel
                    </Button>
                    <Button variant="contained" className={classes.saveButton} classes={{ disabled: classes.saveButtonDisabled }} disabled={confirmDisabled}
                        onClick={event => submit(event)}
                    >
                        Save
                    </Button>

                </SideBarDialogActions>

            </Drawer>

            {enterDaysFlag && <EnterDaysDialog open={enterDaysFlag} onClose={handleDaysDialogClose} onConfirm={handleDaysDialogConfirm} />}

        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchEditInvoice: (invoiceId, invoiceData, onSuccess, onFailure) => {
        dispatch(editInvoice(invoiceId, invoiceData, onSuccess, onFailure))
    },
    dispatchGetInvoiceConfig: (onSuccess, onFailure) => {
        dispatch(invoiceConfig(onSuccess, onFailure))
    },
    dispatchChatView: (value) => dispatch(updateChatView(value)),

});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetailsSideBar);;